import * as React from 'react';
// @ts-expect-error
import {Controller} from 'react-hook-form';
// @ts-expect-error
import type {Control, Watch} from 'react-hook-form';

import {EditableLabelButton} from 'shells/editable-label/editable-label-button';

type Props = {
    control: Control;
    name: string;
    watch: Watch;
};

export function SubmitButtonField(props: Props) {
    const color = props.watch(`${props.name}.color`);
    const backgroundColor = props.watch(`${props.name}.backgroundColor`);
    const fontSize = props.watch(`${props.name}.fontSize`);
    const fontWeight = props.watch(`${props.name}.fontWeight`);
    const justifyContent = props.watch(`${props.name}.justifyContent`);
    const borderRadius = props.watch(`${props.name}.borderRadius`);

    return (
        <div style={{display: 'flex', width: '100%', justifyContent}}>
            <Controller
                name={`${props.name}.label`}
                control={props.control}
                // @ts-expect-error
                render={({field}) => (
                    <EditableLabelButton
                        value={field.value}
                        onSaveNewValue={(newValue) => {
                            field.onChange(newValue);

                            return new Promise((resolve) => {
                                // @ts-expect-error
                                resolve();
                            });
                        }}
                        // @ts-expect-error
                        allowSavingEmpty={false}
                        shouldAllowUndo={false}
                        tooltip={null}
                        customStyle={{
                            fontSize: `${fontSize}px`,
                            fontWeight,
                            backgroundColor,
                            color,
                            borderRadius: `${borderRadius}px`,
                        }}
                    />
                )}
            />
        </div>
    );
}
